import { useLoadGate } from '@/lib/useLoadGate';

/** The upload ban, shown on every upload surface while an import runs. One load
 *  writes at a time (the VDB-collision ban), so uploads are paused until it
 *  finishes — but the rest of the system stays usable.
 *
 *  It deliberately does NOT promise an email yet: SES is not out of the sandbox,
 *  and a "we'll email you" line can't appear until it actually delivers (works
 *  as advertised). The email sentence is added here when SES goes live. */
export function LoadBanBanner() {
  const load = useLoadGate();
  if (!load) return null;
  const heading =
    load.kind === 'clear'
      ? 'Clearing data'
      : load.kind === 'queued-clear'
        ? 'Clears queued'
        : 'Import in progress';
  return (
    <div className="mb-4 flex items-start gap-3 rounded-md border border-tres-action/40 bg-tres-action/10 p-3 text-sm">
      <span
        className="mt-0.5 inline-block h-2 w-2 flex-shrink-0 animate-pulse rounded-full bg-tres-action"
        aria-hidden
      />
      <div className="text-tres-text-primary">
        <span className="font-semibold">{heading}</span> — {load.label}. Uploads are paused until
        it completes; you can keep using the rest of the system in the meantime.
      </div>
    </div>
  );
}
